import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Deliverables from './components/Deliverables';
import SocialProof from './components/SocialProof';
import Process from './components/Process';
import Authority from './components/Authority';
import UrgencyRisk from './components/UrgencyRisk';
import BookingForm from './components/BookingForm';
import Footer from './components/Footer';

function App() {
  return (
    // Removed overflow-x-hidden from here to prevent the double vertical scrollbar bug
    <div className="bg-navy text-slate-200 selection:bg-teal-500/30 selection:text-white">
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <Deliverables />
        <SocialProof />
        <Process />
        <Authority />
        <UrgencyRisk />
        <BookingForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;